/*
 * Turns ==this== into a marker stroke, anywhere on the page.
 *
 * Theme settings hand back escaped plain text for headings, so there is no way
 * to put a span around one word from the editor. A marker in the copy is the
 * only thing that survives the round trip — and it reads clearly enough that
 * whoever edits the page next will work out what it does without being told.
 */

(() => {
  const TARGETS = 'h1, h2, h3, h4, h5, .rte p, .rte li, .banner__text, p.title';
  const PATTERN = /==([^=]+)==/g;

  const paint = (root) => {
    root.querySelectorAll(TARGETS).forEach((el) => {
      if (el.dataset.markerDone === 'true') return;
      // Only walk text nodes, so any markup already inside is left alone.
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      const hits = [];
      let node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.includes('==')) hits.push(node);
      }
      if (!hits.length) return;

      hits.forEach((text) => {
        const frag = document.createDocumentFragment();
        let last = 0;
        let match;
        PATTERN.lastIndex = 0;
        while ((match = PATTERN.exec(text.nodeValue))) {
          if (match.index > last) {
            frag.appendChild(document.createTextNode(text.nodeValue.slice(last, match.index)));
          }
          const mark = document.createElement('span');
          mark.className = 'marker';
          mark.textContent = match[1];
          frag.appendChild(mark);
          last = match.index + match[0].length;
        }
        if (!last) return;
        if (last < text.nodeValue.length) {
          frag.appendChild(document.createTextNode(text.nodeValue.slice(last)));
        }
        text.parentNode.replaceChild(frag, text);
      });
      el.dataset.markerDone = 'true';
    });
  };

  paint(document);

  // The theme editor re-renders a section on every keystroke, so freshly
  // written markers need painting too.
  document.addEventListener('shopify:section:load', (event) => paint(event.target));
})();
